export default "/images/group.svg?03c53a03b15f433d40b87db8a4d8f793";